import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { root_path } from '@routes';
import { FreeProTrialParams, freeProTrial } from '@utils/backend-api/subscribe';

const useFreeProTrial = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: FreeProTrialParams) => freeProTrial(params),
    {
      onSuccess: () => {
        const anchor = document.createElement('a');
        anchor.href = root_path();
        anchor.click();
      },
      onError: () => {
        toast.error('Something went wrong. Please try again later.');
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useFreeProTrial;
